<p>productproperty works!</p>
